import React, { useEffect, useState } from "react";
import About from "./About";
import Calender from "./Calender";
import Cellgroups from "./Cellgroups";
import Ministries from "./Ministries";
import PrayerReq from "./PrayerReq";
import ReactWhatsapp from 'react-whatsapp';
import "pure-react-carousel/dist/react-carousel.es.css";
import { useNavigate } from "react-router-dom";
import Testimony from "./Testimonies";
import DailyScripture from "./DailyScripture";
import { API_URL } from "./config";

const Blank = () => {
  const navigate = useNavigate();
  const [activeComponent, setActiveComponent] = useState("Refresh");
  const [hasNewNotifications, setHasNewNotifications] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const isMobile = window.innerWidth < 600;

  useEffect(() => {
    localStorage.removeItem("selectedMinistry");
  }, []);

  useEffect(() => {
    const asyncFetch = async () => {
      const userId = localStorage.getItem("UserID");
      try {
        let res = await fetch(`${API_URL}/members/check/notification/user/${userId}`, {
          method: "get",
          headers: {
            "Content-Type": "application/json",
          },
        });

        let responseJson = await res.json();
        console.log(responseJson[0].notification);

        if( responseJson[0].notification === "T") {
          setHasNewNotifications(true);
        }

      } catch (error) {
        console.error("Error:");
      }
    }

    asyncFetch();
  }, []);

  const handleButtonClick = (component) => {
    setActiveComponent(component);
  };

  const getButtonStyle = (component) => {
    return {
      marginBottom: "10px",
      marginRight: "10px",
      minWidth: "150px",
      width: isMobile ? "150px" : "200px",
      height: "45px",
      border: "1px solid #000000",
      borderRadius: "10px",
      borderWidth: "0px",
      backgroundColor: activeComponent === component ? "#1a6363" : "#B5D3CF",
      color: activeComponent === component ? "#ffffff" : "#000000",
      flexShrink: 0
    };
  };

  return (
    <div style={{
      // width: '90%',
      // maxWidth: '1200px',
      // margin: '0 auto',
      // padding: '0 15px',
      // boxSizing: 'border-box',
      // marginBottom: '80px'
    }}>
      {/* Search Bar and Notification Bell Row */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        width: '99%',
        maxWidth: '1100px',
        marginTop: '10px',
        margin: '0 auto',
        padding: '0 15px',
        marginBottom: '20px'
      }}>
        {/* Search Bar - takes remaining space */}
        <div style={{ flex: 1 }}>
          <form className="nosubmit">
            <input
              className="nosubmit form-control"
              type="search"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ width: '100%' }}
            />
          </form>
        </div>

        {/* Notification Bell with Badge */}
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <i
            className="material-icons"
            style={{
              fontSize: "42px",
              color: "#FFD700",
              cursor: 'pointer',
              flexShrink: 0
            }}
            onClick={() => navigate("/notifications")}
          >
            circle_notifications
          </i>

          {/* Red dot badge - appears only if hasNewNotifications is true */}
          {hasNewNotifications && (
            <div style={{
              position: 'absolute',
              top: '5px',
              right: '5px',
              width: '12px',
              height: '12px',
              backgroundColor: 'red',
              borderRadius: '50%',
              border: '2px solid #FF0000' // Optional: makes the dot stand out more
            }}></div>
          )}
        </div>
      </div>

      {/* Navigation Buttons */}
      <div style={{
        width: '95%',
        overflowX: 'auto',
        margin: '20px auto 0 auto',
        WebkitOverflowScrolling: 'touch'
      }}>
        <div style={{
          display: 'flex',
          gap: '10px',
          paddingBottom: '10px',
          width: 'max-content'
        }}>
          <button
            style={getButtonStyle("Refresh")}
            onClick={() => handleButtonClick("Refresh")}
          >
            Home
          </button>
          <button
            style={getButtonStyle("About")}
            onClick={() => handleButtonClick("About")}
          >
            About
          </button>
          <button
            style={getButtonStyle("DailyScripture")}
            onClick={() => handleButtonClick("DailyScripture")}
          >
            Daily Scripture
          </button>
          <button
            style={getButtonStyle("Ministries")}
            onClick={() => handleButtonClick("Ministries")}
          >
            Ministries
          </button>
          <button
            style={getButtonStyle("Calender")}
            onClick={() => handleButtonClick("Calender")}
          >
            Calendar
          </button>
          <button
            style={getButtonStyle("Cellgroups")}
            onClick={() => handleButtonClick("Cellgroups")}
          >
            Home Groups
          </button>
          <button
            style={getButtonStyle("PrayerReq")}
            onClick={() => handleButtonClick("PrayerReq")}
          >
            Prayer Requests
          </button>
          <button
            style={getButtonStyle("Testimony")}
            onClick={() => handleButtonClick("Testimony")}
          >
            Testimonies
          </button>
        </div>
      </div>

      {/* Content Area */}
      <div style={{
        width: '100%',
        padding: '0',
        marginTop: '20px',
        boxSizing: 'border-box'
      }}>
        {activeComponent === "About" && <About />}
        {activeComponent === "DailyScripture" && <DailyScripture />}
        {activeComponent === "Ministries" && <Ministries searchQuery={searchQuery} />}
        {activeComponent === "Calender" && <Calender searchQuery={searchQuery} />}
        {activeComponent === "Cellgroups" && <Cellgroups searchQuery={searchQuery} />}
        {activeComponent === "PrayerReq" && <PrayerReq searchQuery={searchQuery} />}
        {activeComponent === "Testimony" && <Testimony searchQuery={searchQuery} />}

        {activeComponent === "Refresh" && (
          <>
            <div style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              marginTop: '10px'
            }}>
              <img
                src={"../parents.jpg"}
                style={{
                  width: isMobile ? "85%" : "30%",
                  height: isMobile ? "270px" : "400px",
                  borderRadius: "10px",
                  objectFit: 'cover'
                }}
                alt="dashboard"
              />
            </div>

            <h4 style={{
              textAlign: "center",
              fontSize: "27px",
              color: "#1a6363",
              marginTop: "10px",
            }}>
              We welcome you
            </h4>

            <p style={{
              color: "#bd7925",
              marginTop: "6px",
              textAlign: 'center'
            }}>
              <em>"Transforming People, Transforming Nations"</em>
            </p>

            <div style={{
              width: '100%',
              padding: isMobile ? '0 10px' : '0 20px',
              textAlign: 'center'
            }}>
              <p style={{ color: "#000000" }}>
                <b>Sunday Service Times:</b> 9am and 11:30am
              </p>
              <p style={{ color: "#000000" }}>
                <b>Location:</b> 147 Robert Mugabe Harare CBD
              </p>
              <p style={{ color: "#000000" }}>
                <b>Contact Details:</b> <br />
                +263 861 270 0020 / +263 78 970 0021 <br />
                http://www.jabulanlcc.org
              </p>

              <div style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '20px 0'
              }}>
                <ReactWhatsapp
                  number="263 78 970 0021"
                  message="Hi, I'd love to connect and learn more about NLCC, Can we chat?"
                  style={{
                    backgroundColor: '#1a6363',
                    height: '40px',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 20px',
                    textDecoration: 'none'
                  }}
                >
                  <p style={{
                    color: 'white',
                    margin: 0
                  }}>
                    Chat on whatsapp
                  </p>
                </ReactWhatsapp>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
    // </div>
  );
};

export default Blank;